import { Flex, Spinner } from "@chakra-ui/react";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import { useCallback, useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import appStore from "store";
import api from "store/api";
import MapInner from "./MapInner";
import MapPointContainer from "./MapPointContainer";
import mapStyles from "./mapStyles.json";

const render = (status) => {
  if (status === Status.FAILURE) {
    console.log("Google Maps API failed to load.");
    return null;
  }
  return (
    <Flex w="100%" h="100%" justify="center" p={8}>
      <Spinner
        size="lg"
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="black"
      />
    </Flex>
  );
};

const Map = ({ stations, configs, center, setCenter, groupPrice, instant_zone_ids }) => {
  const { tempSelectedZoneId, isSearchAirport, selectedDays, orders } =
    appStore;
  // console.log("tempSelectedZoneId", tempSelectedZoneId);
  const [zoom, setZoom] = useState(15);
  const [bounds, setBounds] = useState(null);
  const [cachedCenter, setCachedCenter] = useState(null);

  useEffect(() => {
    if (isSearchAirport) {
      setCenter({ lat: 25.080531, lng: 121.237707 });
    }
  }, [isSearchAirport]);

  const handleMapClick = (e) => {
    // console.log("e", e);
  };
  const handleMapDrag = (e) => {
    // console.log("e", e);
  };

  const handleMapBoundsChanged = useCallback(
    (map) => {
      /**
       * map.getBounds() 回傳的是 LatLngBounds 物件
       * Ia: Object { lo: 121.507224682312, hi: 121.56773531768798 }
       * Ua: Object { lo: 25.050294531599928, hi: 25.065844975085803 }
       * lo: 25.058069753342865,121.507224682312 (左下角座標)
       * hi: 25.065844975085803,121.56773531768798 (右上角座標)
       */

      const bounds = map.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      setBounds({
        ne: { lat: ne.lat(), lng: ne.lng() },
        sw: { lat: sw.lat(), lng: sw.lng() },
      });

      // console.log('map:onBoundsChanged', map.getBounds());
    },
    [setBounds]
  );

  const handleMapCenterChanged = useCallback((map) => {
    const center = map.getCenter();
    setCachedCenter({ lat: center.lat(), lng: center.lng() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMapZoomChanged = useCallback((map) => {
    setZoom(map.getZoom());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper
      apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}
      render={render}
      options={{
        // Add options to enable control panel
        fullscreenControl: true,
        mapTypeControl: true,
        zoomControl: true,
      }}
      libraries={["places", "geometry", "drawing", "visualization"]}
    >
      <input
        type="hidden"
        id="m"
        value={process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}
      />
      <MapInner
        center={center}
        zoom={zoom}
        onClick={handleMapClick}
        onDrag={handleMapDrag}
        onBoundsChanged={handleMapBoundsChanged}
        onCenterChanged={handleMapCenterChanged}
        onZoomChanged={handleMapZoomChanged}
        mapStyles={mapStyles}
      >
        {stations?.map((point, index) => {
          // if (
          //   point.supportConfigs.length === 0 ||
          //   point.lat === undefined ||
          //   point.lng === undefined ||
          //   point.lat === null ||
          //   point.lng === null
          // ) {
          //   return;
          // }

          return (
            <MapPointContainer
              key={`map-point-${point.id}`}
              data={point}
              isOpen={true}
              groupPrice={groupPrice}
              index={index}
              instant_zone_ids={instant_zone_ids}
            />
          );
        })}
      </MapInner>
    </Wrapper>
  );
};
export default Map;
